// To use :
//   in a container around all line items and the add button have '.nested-association-wrapper-js'
//   assign the container wrapping line items '.collection-js'
//   give the button for adding '.build-nested-association-button-js'
//
//   and then do observe the button like so:
//     $('.build-nested-association-button-js').on 'click', (event) =>
//       Sprinkles.BuildNestedAssociationButton.build event
//
const BuildNestedAssociationButton = {
  build(e, callback) {
    // setup things we care about
    if (callback == null) {
      callback = null
    }
    const addButton = $(e.target)
    const wrapper = addButton.closest(".nested-association-wrapper-js")
    const collectionWrapper = wrapper.find(".collection-js")
    const renderedFields = addButton.data("rendered-fields")

    // take pre-rendered empty fields and append to collection
    collectionWrapper.append(renderedFields)

    // hook into after build if you want
    return typeof callback === "function" ? callback() : undefined
  }
}

export default BuildNestedAssociationButton
